import { Injectable } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IndexadorAtualizacaoGarantiaCreditoLivre } from 'src/app/model/indexador-atualizacao-garantia-credito-livre';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class IndexadoresService extends FgiBackEndService<IndexadorAtualizacaoGarantiaCreditoLivre> {

  getNewEntity(): IndexadorAtualizacaoGarantiaCreditoLivre {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/indexadores-atualizacao-garantia'
  }

  public paginarIndexadores(pagina: number, limite: number = 10): Observable<ResultadoPaginado<IndexadorAtualizacaoGarantiaCreditoLivre>> {
    const options: any = blockUi();
    options.params.pagina = pagina;
    options.params.limite = limite;
    return this.http.get<ResultadoPaginado<IndexadorAtualizacaoGarantiaCreditoLivre>>(`${this.BASE_URL}/paginar`, options).pipe
      (catchError((e) => this.handleError(3))) as Observable<any>
  }
}
